var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraph2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 50,
    viewBox: "0 0 209 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0L11.6048 3.14534C23.1011 6.29067 46.3107 12.4729 69.4118 13.5575C92.5129 14.6421 115.722 10.4121 138.824 8.35141C161.925 6.29067 185.134 6.29067 196.631 6.29067H208.235V50H196.631C185.134 50 161.925 50 138.824 50C115.722 50 92.5129 50 69.4118 50C46.3107 50 23.1011 50 11.6048 50H0V0Z",
    fill: "url(#paint0_linear_137_612)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_137_612",
    x1: 104.118,
    y1: 0,
    x2: 104.118,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A034FA",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A034FA",
    stopOpacity: 0.02
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph2);
export default __webpack_public_path__ + "static/media/graph2.6139223f178d4f5c800124b0b67bc4a8.svg";
export { ForwardRef as ReactComponent };